import { render, staticRenderFns } from "./RoskildeButtonGroup.vue?vue&type=template&id=0fae706e&scoped=true&"
import script from "./RoskildeButtonGroup.vue?vue&type=script&lang=js&"
export * from "./RoskildeButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./RoskildeButtonGroup.vue?vue&type=style&index=0&id=0fae706e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae706e",
  null
  
)

export default component.exports